import React from "react";

const WebStoreInquiry = () => {
  return (
    <div className="w-full bg-white">
      <div className="container max-w-[1240px] mx-auto w-full h-[335px] flex flex-col">
        <h3 className="w-[115px] h-[27px] font-semibold text-[18px] text-black text-start">
          Send Inquiry
        </h3>
        <hr className="w-[162px] h-[3px] bg-[#FF6300] text-start mt-[8px]" />
        <div className="w-[1240px] h-[203px] bg-white rounded-[10px] py-[15px] px-[21px] flex flex-col border mt-[21px] gap-y-[15px]">
          <div className="w-[250px] h-[24px] text-start text-black flex gap-x-[4px]">
            <p className="font-medium text-[16px]">Message to :</p>
            <p className="font-semibold text-[16px]">ABC Creations</p>
          </div>
          <input
            type="text"
            className="w-[588px] h-[21px] text-black font-medium text-[14px] text-start placeholder:text-[#BEBEBE] resize"
            placeholder="Enter Product Detail Such as  color , size , material  and other specific requirements ."
          />
        </div>
        <div className="w-full h-[42px] flex items-center justify-center mt-[26px]">
          <button className="w-[160px] h-[42px] bg-[#FF6300] flex items-center justify-center gap-x-[10px] rounded-[5px]">
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_360_597)">
                <path
                  d="M7.58301 10.4167L15.3747 2.625"
                  stroke="white"
                  stroke-width="1.83333"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M15.3747 2.625L10.7706 15.375C10.7395 15.4428 10.6896 15.5003 10.6268 15.5406C10.564 15.5809 10.491 15.6023 10.4164 15.6023C10.3418 15.6023 10.2688 15.5809 10.206 15.5406C10.1432 15.5003 10.0933 15.4428 10.0622 15.375L7.58308 10.4167L2.62474 7.9375C2.55693 7.90642 2.49946 7.85653 2.45917 7.79375C2.41888 7.73096 2.39746 7.65793 2.39746 7.58333C2.39746 7.50873 2.41888 7.4357 2.45917 7.37292C2.49946 7.31014 2.55693 7.26024 2.62474 7.22917L15.3747 2.625Z"
                  stroke="white"
                  stroke-width="1.83333"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </g>
              <defs>
                <clipPath id="clip0_360_597">
                  <rect
                    width="17"
                    height="17"
                    fill="white"
                    transform="translate(0.5 0.5)"
                  />
                </clipPath>
              </defs>
            </svg>
            <p className="w-[88px] h-[21px] text-white font-medium text-[14px]">
              Send Inquiry
            </p>
          </button>
        </div>
      </div>
    </div>
  );
};

export default WebStoreInquiry;
